export default {
    contractListItem: {
        noCounterparty: '(no counterparty)',
        viewPosition: 'View position',
    },
}
